function Hero() {
  return (
    <section id="hero-section" className="portfolio-section p-4 p-md-5 mb-4 text-center">
      <p className="text-uppercase text-primary fw-semibold mb-2">Welcome to my portfolio</p>
      <h1 className="hero-title mb-3">Ryan Hodge</h1>
      <p className="hero-subtitle mb-4">
        I create thoughtful digital experiences, explore emerging technologies, and turn ideas into simple,
        useful products. Come join me in this adventure.
      </p>
      <div className="d-flex justify-content-center gap-2 flex-wrap">
        <span className="badge rounded-pill hero-pill px-3 py-2">Creative Problem Solver</span>
        <span className="badge rounded-pill hero-pill px-3 py-2">Lifelong Learner</span>
        <span className="badge rounded-pill hero-pill px-3 py-2">Team Collaborator</span>
      </div>
    </section>
  );
}

export default Hero;
